import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import { getReadingTypographyCssVars } from "../../../../../lib/typography/readingTypography";

import "../styles/default.scss";

const ReadingTypography = ({ html, className }) => {
  if (!html) {
    return null;
  }

  return (
    <div
      className={classNames("reading-typography", className)}
      style={getReadingTypographyCssVars()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

ReadingTypography.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string
};

export default ReadingTypography;
